import { createApi } from "@reduxjs/toolkit/query/react";
import {baseQueryWithReAuth} from "@/store/api/baseQueryWithReAuth";
export interface SIC {
  sic: number;
  sic_name: string;
  sic_code: string;
}
export interface OrderItems {
  id: number;
  package_name: string;
  status: number;
}
export interface RecurringServices {
  id: number;
  package_name: string;
  status: number;
}
export interface Company {
  id: number;
  name: string;
  state_name: string;
  industry: string;
  client: number;
  client_first_name: string;
  client_last_name: string;
  client_address: string;
  client_country_code: string;
  client_phone: string;
  country_type: string;
  client_email?: string;
  client_auth_status?: boolean;
  client_refer_code?: string;
  client_deposit?: number;
  order_item_list: OrderItems[];
  recurring_service_list: RecurringServices[];
  company_number: string;
  sic_list: SIC[];
  authorized_capital?: string | number;
  service_address?: string;
  office_number?: string;

  member_submitted: number;
  identity_verification_status: number;
  shareholder_status: number;
}

export const companyApi = createApi({
  reducerPath: "companyApi",
  baseQuery: baseQueryWithReAuth,
  endpoints: (builder) => ({
    getCompanies: builder.query<Company[], void>({
      query: () => "/client-company",
    }),
  }),
});

export const { useGetCompaniesQuery } = companyApi;
